import { Deserializable } from '../interfaces';

export class TypeService implements Deserializable {
  idTipoServicio: number;
  descripcion: string;

  constructor() {
    this.idTipoServicio = 0;
    this.descripcion = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
